import {Box, Grid, Typography, useTheme} from "@mui/material";
import React from "react";

export const PostFilters = ({ filters, sx }) => {
    const theme = useTheme();

    return <Grid container sx={sx}>
        {filters?.map((filter) => {
            return <Grid item key={"post-filter-" + filter.label} sx={{margin: "0 10px 10px 0"}}>
                <Box sx={{backgroundColor: theme.palette.grey["100"], padding: "10px 25px", borderRadius: "10px"}}>
                    <Typography sx={{color: theme.palette.grey["600"], fontSize: "12px"}}>{filter.label}</Typography>
                    <Typography sx={{fontWeight: "bold", fontSize: "16px"}}>{filter.value}</Typography>
                </Box>
            </Grid>
        })}
    </Grid>
}